import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

function InlineSpinner(props: any) {
  return (
    <CircularProgress size="1rem" style={{ color: 'var(--color-theme-primary)' }}/>
  );
}

export default InlineSpinner;
